<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="名称及编号">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_testBasis" @onRefresh="getTableData()">
        <el-button v-auth="'testBasis:edit'" type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="basisCode" label="标准号" align="center" width="180" fixed></el-table-column>
        <el-table-column
          prop="basisName"
          label="依据的标准名称及编号（含年号）"
          min-width="240"
          header-align="center"
        ></el-table-column>
        <el-table-column prop="fileName" label="关联文件" align="center" min-width="200">
          <template v-slot="{ row }">
            {{ row.fileName }}
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="160" align="center"></el-table-column>

        <el-table-column label="操作" width="200" header-align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link v-auth="'testBasis:edit'" type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link v-auth="'testBasis:delete'" type="danger" @click="handleDelete(row)">删除</el-link>
            <el-link v-if="row.fileName" type="primary" @click="handleDownload(row)">下载文件</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <BasisEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <BasisDetail :visible.sync="detailVisible" :activeId="activeRowId" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import BasisEdit from './components/BasisEdit';
import BasisDetail from './components/BasisDetail';

import { getBasisList, deleteBasis } from '@/api/system';

export default {
  components: { TableHeader, BasisEdit, BasisDetail },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        keyword: '',
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowId: null,
      detailVisible: false,
      editVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getBasisList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleDownload(row) {
      if (!row.filePath) return this.$message.warning('暂无对应文件!');
      const timestamp = new Date().getTime();
      const encodedFileUrl = encodeURIComponent(row.filePath);
      const fullUrl = `${process.env.VUE_APP_BASE_API}/${encodedFileUrl}?t=${timestamp}`;

      // 创建一个隐藏的<a>标签
      const link = document.createElement('a');
      link.href = fullUrl;
      link.download = row.fileName || '档案文件'; // 设置下载的文件名
      document.body.appendChild(link);
      link.click(); // 触发点击事件开始下载
      document.body.removeChild(link); // 下载完成后移除<a>标签
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteBasis({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped></style>
